/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Company_HintInputs */

const cs_auth_signup_company_hint = /** @type {(inputs: Auth_Signup_Company_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepovinné firemní údaje pro faktury. Můžete je doplnit později.`)
};

const en_auth_signup_company_hint = /** @type {(inputs: Auth_Signup_Company_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional company details for invoices. You can fill this in later.`)
};

/**
* | output |
* | --- |
* | "Optional company details for invoices. You can fill this in later." |
*
* @param {Auth_Signup_Company_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_company_hint = /** @type {((inputs?: Auth_Signup_Company_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Company_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_company_hint(inputs)
	return cs_auth_signup_company_hint(inputs)
});